import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Description from './Description';
import RoundImage from './RoundImage';
import Name from './Name';
import Title from './Title';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
`;

const Member = props => {
  const [showDescription, setShowDescription] = useState(false);
  const { img, name, title } = props;

  return (
    <Container onClick={() => setShowDescription(true)}>
      <RoundImage src={img} alt={name} />

      <Name>{name}</Name>
      <Title>{title}</Title>

      {showDescription && (
        <Description {...props} onClose={() => setShowDescription(false)} />
      )}
    </Container>
  );
};

export default Member;
